/**
 * 
 * password Setup page
 * 
 */

import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { useSelector,useDispatch} from "react-redux"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Label,
    Button,
    Input,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import * as passwordAction from "../../store/YmRtUGFzc3/actions"
import { isEmpty } from "lodash"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import ButtonSpinner from "../../components/ButtonSpinner"
import BootstrapTable from "react-bootstrap-table-next"
import Modal from "react-bootstrap/Modal"

const BdmPasswordSetup = (props) => {
    const title = "Reset Password"

    const { dispatch } = props
    const specificDispatch = useDispatch()

    //const { SearchBar } = Search

    useEffect(() => {
        dispatch(passwordAction.loadRecordsMetaData())
    }, [])


    const permissionUpdate = useSelector(
        (specificstate) => specificstate.bdmPasswordSetup
    )
    const {
        passwordData = [],
        recordsMetaData = {}
    } = permissionUpdate

    console.log(permissionUpdate, "update")
    //dropdown list
    const [bdmCode, setBdmCode] = useState([])
    //fuse options for venue(autocomplete field)
    const fuseOptions = {
        keys: ["empCode", "label"],
    }
    const [modal, setModal] = useState(false)
    // const[showpassword,setShowpassword] = useState(false)
    const [btnLoader, setBtnLoader] = useState(false)
    const [viewTable, setViewTable] = useState(false)

    const [empKey, setEmpKey] = useState(false)
    const resetForm = () => {
        setEmpKey(true)
        setBdmCode([])
        setTimeout(() => { setEmpKey(false) }, 0)
        setViewTable(false)
    }
    const applyfilter = () => {
        var searchBdm =
            bdmCode && bdmCode.value ? bdmCode.value : ""
        var searchValue = {}
        if (searchBdm) {
            searchValue.bdmId = searchBdm
        }
        console.log("searchCompany", searchValue)
        if (!isEmpty(searchValue)) {
            specificDispatch(passwordAction.loadPassword(searchValue))
            setViewTable(true)
            setBtnLoader(true)
            setTimeout(() => {
                setBtnLoader(false)
            }, 2000)
        }
    }
   // const [showPassword, setShowPassword] = useState(false)
    const [bdmId,setBdmId] = useState("")
    const passwordDataTable = viewTable && !isEmpty(passwordData)
        ? passwordData.map((data, index) => {
            const password = data.base64Password
            return {
                bdmId: data._id,
                bdmCode: data.bdmCode?data.bdmCode:"--",
                bdmName: data.bdmName?data.bdmName:"--",
                mobileNo:data.mobileNo?data.mobileNo:"--",
                emailId:data.emailId?data.emailId:"--",
                password: (<div style={{display:"flex"}}>
                <Input type = "password" value = {password} onChange={(e)=>{console.log(e)}} id ="myInput"/>
                <span className ="p-viewer"  onClick={()=>{var x =  document.getElementById("myInput")
                 var y =  document.getElementById("class")
                    if (x.type === "password") {
                        x.type = "text"
                        y.className = "fas fa-eye-slash icon-btn"
                      } else {
                        x.type = "password"
                        y.className = "fas fa-eye icon-btn"
                      }
                }}>
                    <i className="fas fa-eye icon-btn"  id ="class"
                     style = {{marginLeft:"-30px",cursor:"pointer",marginTop:"10px"}} ></i></span>
               </div>
            ),
                resetPassword: (
                    <Button
                        type="submit"
                        onClick={() => {
                            setModal(true)
                            setBdmId(data._id)
                        }}
                        className="btn btn-warning"
                        style={{ fontSize: "13px" }}
                    >
                        Reset Password
                    </Button>
                ),
                key: index,
            }
        }) : []

    //pagination table data columns
    const columns = [
        {
            dataField: "bdmCode",
            text: "Bdm Account Code",
            headerStyle: {
                minWidth: "170px",
            },
        },
        {
            dataField: "bdmName",
            text: "Bdm Account Name",
            headerStyle: {
                minWidth: "170px",
            },
        },
        {
            dataField: "mobileNo",
            text: "Mobile Number",
            headerStyle: {
                minWidth: "130px",
            },
        },
        {
            dataField: "emailId",
            text: "Email Id",
            headerStyle: {
                minWidth: "130px",
            },
        },
        {
            dataField: viewTable ? "password" : null,
            text: "Password",
            headerStyle: {
                minWidth: "160px",
            },
        },
        {
            dataField: "resetPassword",
            text: "Reset Password",
            headerStyle: {
                minWidth: "160px",
            },
        },
    ]
  

  

    const resetFunction = () => {
        const changeData = {
            "bdmId": bdmId
        }
        console.log("mychecking", changeData)
        specificDispatch(passwordAction.changePassword(changeData))
        setTimeout(() => {
            setModal(false)
        }, 400)
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{title} | Zero Gravity CRM</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title={"Master"} breadcrumbItem={title} />

                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                  
                                        <Row>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className={"form-label"}
                                                        htmlFor={"Vendor Code - Name"}
                                                    >
                                                        {"Bdm Account Code - Name"}
                                                    </Label>
                                                </div>
                                                <ReactSearchAutocomplete
                                                    name="bdmCode"
                                                    key={empKey}
                                                    items={recordsMetaData.bdmOptions}
                                                    value={bdmCode}
                                                    type="autoComplete"
                                                    resultStringKeyName="label"
                                                    showIcon={false}
                                                    onSelect={(e) => setBdmCode(e)}
                                                    onChange={(e) => setBdmCode(e.target.value)}
                                                    placeholder="Enter Bdm Account Code"
                                                    fuseOptions={fuseOptions} // Search on both fields
                                                    styling={{
                                                        height: "34px",
                                                        border: "1px solid #ced4da",
                                                        borderRadius: "4px",
                                                        backgroundColor: "white",
                                                        boxShadow: "none",
                                                        hoverBackgroundColor: "#E40D8C",
                                                        color: "black",
                                                        fontSize: "12px",
                                                        fontFamily: "Courier",
                                                        iconColor: "green",
                                                        clearIconMargin: "3px 8px 0 0",
                                                        zIndex: 10,
                                                    }}

                                                />
                                            </Col>
                                            <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                                                <div style={{ marginTop: "27px", float: "left" }}>
                                                    <Button
                                                        type="button"
                                                        onClick={() => applyfilter()}
                                                        className="btn btn-info btn-label simple-form-applyfilter-btn"
                                                    >
                                                        <i className="bx bx-search-alt label-icon"></i>
                                                        {btnLoader && btnLoader ? (
                                                            <ButtonSpinner />
                                                        ) : (
                                                            "Search"
                                                        )}{" "}
                                                    </Button>
                                                  
                                                    <Button
                                                        type="button"
                                                        onClick={() => resetForm()}
                                                        className="btn btn-danger btn-label simple-form-Reset-btn ms-3"
                                                    >
                                                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                        Reset
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                   
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row >
                        <Col>
                            <Card>
                                <CardBody>
                                    <BootstrapTable keyField='_id' data={passwordDataTable} columns={columns} striped />

                                </CardBody>
                            </Card>
                        </Col>

                        {modal && (
                            <Modal show={modal} size="md" >
                                <Modal.Header
                                    style={{
                                        backgroundColor: "#E40D8C",
                                        color: "white",
                                        minHeight: "65px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                    }}
                                >

                                    <p className="text-nowrap">Reset Password</p>

                                </Modal.Header>
                                <Modal.Body>
                                Are you sure you want to reset your password?
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        className="btn btn-danger"
                                        onClick={() =>
                                            setModal(false)

                                        }
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="btn btn-success"
                                        onClick={() =>
                                            resetFunction()
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        )}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

BdmPasswordSetup.propTypes = {
    dispatch: PropTypes.func,
    searchProps: PropTypes.func,
    baseProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(BdmPasswordSetup)
)
